import Datepicker from 'vuejs-datepicker';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import vClickOutside from 'v-click-outside';
import {mask} from 'vue-the-mask';
import PostedOffers from '../PostedOffers/PostedOffers';
var qs = require('qs');
export default {
    name: 'OpsDashboard',
    components: {
        VuePerfectScrollbar,
        Datepicker,
        PostedOffers
    },
    directives: {
        clickOutside: vClickOutside.directive,
        mask,
    },
    data: function () {
        return {
            states: ['NY', 'Toronto'],
            state: null,
            initial: null,
            patient_first_name: '',
            last_name: '',
            insurance: '',
            body_parts: '',
            address: '',
            suite: '',
            city: '',
            zip_code: '',
            region: '',
            home_tel: '',
            mobile_tel: '',
            call_notification: false,
            text_notification: false,
            note: '',
            treatment: '',
            date: '',
            asap: false,
            therapist: [],
            regions: [],
            openTherapist: false,
            offer_in: false,
            full_time_in: false,
            part_time2_in: false,
            part_time1_in: false,
            offer_out: false,
            full_time_out: false,
            part_time2_out: false,
            part_time3_out: false,
            part_time4_out: false,
            part_time5_out: false,
            part_time6_out: false,
            part_time7_out: false,
            part_time8_out: false,
            part_time1_out: false,
            show: false,
            test: true,
            selectRegions: [],
            openRegion: false,
            postedOfferId: null,
            offerDetail: {
                patient_first_name: '',
                patient_last_name: '',
                insurance: '',
                body_parts: '',
                address: '',
                suit_apt: '',
                city: '',
                zip_code: '',
                region: '',
                home_phone: '',
                mobile_phone: '',
                notes: '',
                based_on_insurance: '',
                available_start_date: '',
                asap: false
            },
            test123: null,
            someValue: 1
        }
    },
    watch: {},
    mounted() {},
    methods: {
        changeState(state) {
            this.state = state;
        }
    }
}